module.exports = __webpack_public_path__ + "img/wx_h5.d4c71133.svg";